import IconButton from '@material-ui/core/IconButton'
import MenuIcon from '@material-ui/icons/Menu'
import clsx from 'clsx'
import React, { useContext, useState } from 'react'
// import { Typography } from '@material-ui/core';
import { Button, Grid, Toolbar } from '@material-ui/core'
import AppBar from '@material-ui/core/AppBar'

import { Link, NavLink, useHistory } from 'react-router-dom'
import ButtonGZ from '../../Button'

import './styles.scss'

import Context from '../../../context'
import useStyles from '../styles'

function TopBar() {
  const classes = useStyles()
  const { openSideBar, setOpenSideBar } = useContext(Context)
  const { aboutCurrentPage } = useContext(Context)
  // const screenList = useContext(screenList);
  const [anchorEl, setAnchorEl] = useState(null)
  const __history = useHistory()

  // const refreshState = history.listen((location, action) => {
  //   setAboutCurrentPage({ ...aboutCurrentPage });
  // });

  const handleDrawerOpen = () => {
    setOpenSideBar(true)
  }

  const handleMenu = event => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  return (
    <AppBar
      position="fixed"
      className={clsx(classes.appBar, {
        [classes.appBarShift]: openSideBar
      })}
    >
      <Grid container xs={12}>
        <Grid item xs={12} justify="center">
          <Toolbar className={`${classes.toolbar} c-header`}>
            <IconButton
              aria-label="open drawer"
              onClick={handleDrawerOpen}
              edge="start"
              className={`${clsx(
                classes.menuButton,
                openSideBar && classes.hide
              )} c-header__menu-button`}
            >
              <MenuIcon style={{ color: '#262061' }} />
            </IconButton>
            <div className={classes.toolbarInfoPage}>
              <div className="c-header__top">
                <h1 className="c-header__title">{aboutCurrentPage.title}</h1>
                <div className={`${classes.infoPageButton}}`}>
                  {aboutCurrentPage?.buttons?.map((button, index) => (
                    <ButtonGZ
                      key={index}
                      component={button.onClick ? undefined : Link}
                      onClick={button.onClick}
                      to={{ pathname: button.pathname, state: button.state }}
                    >
                      {button.title}
                    </ButtonGZ>
                  ))}
                  {aboutCurrentPage?.showBackButton && (
                    <ButtonGZ onClick={__history.goBack}>Voltar</ButtonGZ>
                  )}
                </div>
              </div>
              <div className="c-header__bottom">
                <div className="c-header__tab__wrapper">
                  {aboutCurrentPage?.tabs?.map((tab, index) => (
                    <Button
                      key={index}
                      component={NavLink}
                      activeClassName="active"
                      className="c-header__tab"
                      to={{ pathname: tab.pathname, state: tab.state }}
                    >
                      {tab.title}
                    </Button>
                  ))}
                </div>
              </div>
            </div>
          </Toolbar>
        </Grid>
      </Grid>
    </AppBar>
  )
}

export default TopBar
